import React from 'react';
import { Switch } from 'react-router-dom';

import { useGetSurveyDashboardByCode } from 'src/hooks/surveyDashboard';
import { DashboardLayout } from 'src/layouts/PublicSurveyLayouts';
import EmptyPrivateLayout from 'src/layouts/EmptyPrivateLayout';
import Error404Page from 'src/pages/Error404Page';
import JobLayout from 'src/layouts/JobLayout';
import JobPage from 'src/pages/JobPage/JobPage';
import PrivateLayout from 'src/layouts/PrivateLayout';
import PublicLayout from 'src/layouts/PublicLayout';
import RootPage from 'src/pages/RootPage';
import Route from 'src/components/Route';
import SSOAuthorizePage from 'src/pages/SSOAuthorizePage';
import SSOAuthorizeEmptyPage from 'src/pages/SSOAuthorizeEmptyPage';
import Auth0CallbackPage from 'src/pages/Auth0CallbackPage';
import SignInPage from 'src/pages/SignInPage';
import UsersPage from 'src/pages/UserPage';
import * as ROUTE from 'src/routes/routes';
import PublicSurveyPage from 'src/pages/PublicSurveyPage';
import SurveyDashboard from 'src/components/SurveyDashboard';

// eslint-disable-next-line react/display-name
export default () => (
  <Switch>
    <Route
      component={RootPage}
      exact
      layout={PrivateLayout}
      path={ROUTE.HOME}
    />

    <Route
      component={SSOAuthorizePage}
      exact
      layout={PublicLayout}
      path={ROUTE.SSO_AUTORIZE}
    />

    <Route
      component={SSOAuthorizeEmptyPage}
      exact
      layout={PublicLayout}
      path={ROUTE.SSO_AUTHORIZE_EMPTY}
    />

    {/* <Route
      component={SignInPage}
      exact
      layout={PublicLayout}
      path={ROUTE.SIGN_IN}
    /> */}

    <Route
      component={Auth0CallbackPage}
      exact
      layout={PublicLayout}
      path={ROUTE.AUTH0_LOGIN_CALLBACK}
    />

    <Route
      async
      component={() => import('src/pages/SignInConfirmationPage')}
      exact
      layout={PublicLayout}
      path={ROUTE.SIGN_IN_CONFIRMATION}
    />

    <Route
      async
      component={() => import('src/pages/RestorePasswordPage')}
      exact
      layout={PublicLayout}
      path={ROUTE.RESTORE_PASSWORD}
    />

    <Route
      async
      component={() => import('src/pages/SetPasswordPage')}
      exact
      layout={PublicLayout}
      path={ROUTE.SET_PASSWORD}
    />

    <Route
      component={PublicSurveyPage}
      exact
      layout={PublicLayout}
      path={ROUTE.PUBLIC_SURVEY}
    />

    <Route
      async
      component={() => import('src/components/SSOScreens/AuthErrorView')}
      exact
      layout={PublicLayout}
      path={ROUTE.SSO_AUTH_ERROR}
    />

    <Route
     component={(props) => <SurveyDashboard {...props} isPublic={true} getDashboardData={useGetSurveyDashboardByCode}/>}
     exact
     layout={DashboardLayout}
     path={ROUTE.PUBLIC_SURVEY_DASHBOARD}
    />

    <Route
      async
      component={() => import('src/pages/UsersPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.USERS}
    />

    <Route
      component={UsersPage}
      exact
      layout={PrivateLayout}
      path={ROUTE.USER}
    />

    <Route
      async
      component={() => import('src/pages/RolesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.ROLES}
    />

    <Route
      async
      component={() => import('src/pages/RolePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.ROLE}
    />

    <Route
      async
      component={() => import('src/pages/FilteringRulesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.FILTERING_RULES}
    />

    <Route
      async
      component={() => import('src/pages/FilteringRulePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.FILTERING_RULE}
    />

    <Route
      async
      component={() => import('src/pages/ProfilePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.PROFILE}
    />

    <Route
      async
      component={() => import('src/pages/MasterDataPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.MASTER_DATA}
    />

    <Route
      async
      component={() => import('src/pages/CompanyTypesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_TYPES}
    />

    <Route
      async
      component={() => import('src/pages/CompanyTypePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_TYPE}
    />

    <Route
      async
      component={() => import('src/pages/CompanyTypeVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_TYPE_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/RegionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.REGIONS}
    />

    <Route
      async
      component={() => import('src/pages/RegionPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.REGION}
    />

    <Route
      async
      component={() => import('src/pages/RegionVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.REGION_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/CompaniesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANIES}
    />

    <Route
      async
      component={() => import('src/pages/CompanyPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY}
    />

    <Route
      async
      component={() => import('src/pages/CompanyVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/CompanyProgramsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_PROGRAMS}
    />

    <Route
      async
      component={() => import('src/pages/CompanyProgramPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_PROGRAM}
    />

    <Route
      async
      component={() => import('src/pages/CompanyProgramVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_PROGRAM_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/CompanyAddressesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_ADDRESSES}
    />

    <Route
      async
      component={() => import('src/pages/CompanyAddressPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_ADDRESS}
    />

    <Route
      async
      component={() => import('src/pages/CompanyAddressVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_ADDRESS_VERSIONS}
    />
    <Route
      async
      component={() => import('src/pages/WorkforceLinksPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.WORKFORCE_LINKS}
    />

    <Route
      async
      component={() => import('src/pages/WorkforceLinkPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.WORKFORCE_LINK}
    />

    <Route
      async
      component={() => import('src/pages/WorkforceLinkVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.WORKFORCE_LINK_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/CompanyLinksPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_LINKS}
    />

    <Route
      async
      component={() => import('src/pages/CompanyLinkPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_LINK}
    />

    <Route
      async
      component={() => import('src/pages/CompanyLinkVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_LINK_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/AddressTypesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.ADDRESS_TYPES}
    />

    <Route
      async
      component={() => import('src/pages/AddressTypePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.ADDRESS_TYPE}
    />

    <Route
      async
      component={() => import('src/pages/AddressTypeVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.ADDRESS_TYPE_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/LinkTypesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.LINK_TYPES}
    />

    <Route
      async
      component={() => import('src/pages/LinkTypePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.LINK_TYPE}
    />

    <Route
      async
      component={() => import('src/pages/LinkTypeVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.LINK_TYPE_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/ResultCategoriesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.RESULT_CATEGORIES}
    />
    <Route
      async
      component={() => import('src/pages/ResultCategoryPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.RESULT_CATEGORY}
    />

    <Route
      async
      component={() => import('src/pages/ResultCategoryVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.RESULT_CATEGORY_VERSION}
    />
    <Route
      async
      component={() => import('src/pages/ResultFamiliesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.RESULT_FAMILIES}
    />

    <Route
      async
      component={() => import('src/pages/ResultFamilyPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.RESULT_FAMILY}
    />

    <Route
      async
      component={() => import('src/pages/ResultFamilyVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.RESULT_FAMILY_VERSION}
    />

    <Route
      async
      component={() => import('src/pages/ResultsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.RESULTS}
    />

    <Route
      async
      component={() => import('src/pages/ResultPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.RESULT}
    />

    <Route
      async
      component={() => import('src/pages/ResultVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.RESULT_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/LawCategoriesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.LAW_CATEGORIES}
    />

    <Route
      async
      component={() => import('src/pages/LawCategoryPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.LAW_CATEGORY}
    />

    <Route
      async
      component={() => import('src/pages/LawCategoryVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.LAW_CATEGORY_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/CurrenciesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.CURRENCIES}
    />

    <Route
      async
      component={() => import('src/pages/CurrencyPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.CURRENCY}
    />

    <Route
      async
      component={() => import('src/pages/SectorsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SECTORS}
    />

    <Route
      async
      component={() => import('src/pages/SectorPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SECTOR}
    />

    <Route
      async
      component={() => import('src/pages/SectorVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SECTOR_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/DepartmentsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.DEPARTMENTS}
    />

    <Route
      async
      component={() => import('src/pages/DepartmentPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.DEPARTMENT}
    />

    <Route
      async
      component={() => import('src/pages/DepartmentVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.DEPARTMENT_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/ReportTemplatesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.REPORT_TEMPLATES}
    />

    <Route
      async
      component={() => import('src/pages/ReportTemplatePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.REPORT_TEMPLATE}
    />

    <Route
      async
      component={() => import('src/pages/NotificationsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.NOTIFICATIONS}
    />

    <Route
      async
      component={() => import('src/pages/NotificationPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.NOTIFICATION}
    />

    <Route
      async
      component={() => import('src/pages/EmailTemplatesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.EMAIL_TEMPLATES}
    />

    <Route
      async
      component={() => import('src/pages/EmailTemplatePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.EMAIL_TEMPLATE}
    />

    <Route
      async
      component={() => import('src/pages/EmailTemplateVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.EMAIL_TEMPLATE_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/TagsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.TAGS}
    />

    <Route
      async
      component={() => import('src/pages/TagPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.TAG}
    />

    <Route
      async
      component={() => import('src/pages/TagVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.TAG_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/TagsConfigurationsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.TAGS_CONFIGURATIONS}
    />

    <Route
      async
      component={() => import('src/pages/TagsConfigurationPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.TAGS_CONFIGURATION}
    />

    <Route
      async
      component={() => import('src/pages/TagsConfigurationVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.TAGS_CONFIGURATION_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/UnitsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.UNITS}
    />

    <Route
      async
      component={() => import('src/pages/UnitPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.UNIT}
    />

    <Route
      async
      component={() => import('src/pages/ErsaMappingsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.ERSA_MAPPINGS}
    />

    <Route
      async
      component={() => import('src/pages/ErsaMappingPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.ERSA_MAPPING}
    />

    <Route
      async
      component={() => import('src/pages/SeveritiesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SEVERITIES}
    />

    <Route
      async
      component={() => import('src/pages/SeverityPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SEVERITY}
    />

    <Route
      async
      component={() => import('src/pages/OtherCodesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.OTHER_CODES}
    />

    <Route
      async
      component={() => import('src/pages/OtherCodePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.OTHER_CODE}
    />

    <Route
      async
      component={() => import('src/pages/HolidayTypesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.HOLIDAY_TYPES}
    />

    <Route
      async
      component={() => import('src/pages/HolidayTypePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.HOLIDAY_TYPE}
    />

    <Route
      async
      component={() => import('src/pages/TimezonesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.TIMEZONES}
    />

    <Route
      async
      component={() => import('src/pages/TimezonePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.TIMEZONE}
    />
    <Route
      async
      component={() => import('src/pages/LanguagesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.LANGUAGES}
    />

    <Route
      async
      component={() => import('src/pages/LanguagePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.LANGUAGE}
    />

    <Route
      async
      component={() => import('src/pages/BusinessUnitsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.BUSINESS_UNITS}
    />

    <Route
      async
      component={() => import('src/pages/BusinessUnitPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.BUSINESS_UNIT}
    />

    <Route
      async
      component={() => import('src/pages/RatingsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.RATINGS}
    />

    <Route
      async
      component={() => import('src/pages/RatingPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.RATING}
    />

    <Route
      async
      component={() => import('src/pages/RatingVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.RATING_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/ChecklistQuestionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.CHECKLIST_QUESTIONS}
    />

    <Route
      async
      component={() => import('src/pages/ChecklistQuestionPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.CHECKLIST_QUESTION}
    />

    <Route
      async
      component={() => import('src/pages/ChecklistQuestionVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.CHECKLIST_QUESTION_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/DatasheetQuestionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.DATASHEET_QUESTIONS}
    />

    <Route
      async
      component={() => import('src/pages/DatasheetQuestionPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.DATASHEET_QUESTION}
    />

    <Route
      async
      component={() => import('src/pages/DatasheetQuestionVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.DATASHEET_QUESTION_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/ScoringsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SCORINGS}
    />

    <Route
      async
      component={() => import('src/pages/ScoringPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SCORING}
    />

    <Route
      async
      component={() => import('src/pages/BusinessUnitVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.BUSINESS_UNIT_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/ProductLinesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.PRODUCT_LINES}
    />

    <Route
      async
      component={() => import('src/pages/ProductLinePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.PRODUCT_LINE}
    />

    <Route
      async
      component={() => import('src/pages/ProductLineVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.PRODUCT_LINE_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/WorkforceHolidaysPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.WORKFORCE_HOLIDAYS}
    />

    <Route
      async
      component={() => import('src/pages/WorkforceHolidayPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.WORKFORCE_HOLIDAY}
    />

    <Route
      async
      component={() => import('src/pages/WorkforceHolidayVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.WORKFORCE_HOLIDAY_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/WorkforceTaxonomiesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.WORKFORCE_TAXONOMIES}
    />

    <Route
      async
      component={() => import('src/pages/WorkforceTaxonomyPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.WORKFORCE_TAXONOMY}
    />

    <Route
      async
      component={() => import('src/pages/WorkforceTaxonomyVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.WORKFORCE_TAXONOMY_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/CountriesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COUNTRIES}
    />

    <Route
      async
      component={() => import('src/pages/CountryPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COUNTRY}
    />

    <Route
      async
      component={() => import('src/pages/CountryVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COUNTRY_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/WorkforcesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.WORKFORCES}
    />

    <Route
      async
      component={() => import('src/pages/WorkforcePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.WORKFORCE}
    />

    <Route
      async
      component={() => import('src/pages/WorkforceVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.WORKFORCE_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/TrainingsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.TRAININGS}
    />

    <Route
      async
      component={() => import('src/pages/TrainingPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.TRAINING}
    />

    <Route
      async
      component={() => import('src/pages/TrainingVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.TRAINING_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/StateProvincesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.STATE_PROVINCES}
    />

    <Route
      async
      component={() => import('src/pages/StateProvincePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.STATE_PROVINCE}
    />

    <Route
      async
      component={() => import('src/pages/ServiceTypesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SERVICE_TYPES}
    />

    <Route
      async
      component={() => import('src/pages/ServiceTypePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SERVICE_TYPE}
    />

    <Route
      async
      component={() => import('src/pages/ServicesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SERVICES}
    />

    <Route
      async
      component={() => import('src/pages/ServicePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SERVICE}
    />

    <Route
      async
      component={() => import('src/pages/ServiceVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SERVICE_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/SchemesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SCHEMES}
    />

    <Route
      async
      component={() => import('src/pages/SchemePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SCHEME}
    />

    <Route
      async
      component={() => import('src/pages/ServiceItemsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SERVICE_ITEMS}
    />

    <Route
      async
      component={() => import('src/pages/ServiceItemPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SERVICE_ITEM}
    />

    <Route
      async
      component={() => import('src/pages/ServiceItemVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SERVICE_ITEM_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/NonCompliancesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.NON_COMPLIANCES}
    />

    <Route
      async
      component={() => import('src/pages/NonCompliancePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.NON_COMPLIANCE}
    />

    <Route
      async
      component={() => import('src/pages/LawsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.LAWS}
    />

    <Route
      async
      component={() => import('src/pages/LawPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.LAW}
    />

    <Route
      async
      component={() => import('src/pages/LawVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.LAW_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/LawNonCompliancesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.LAW_NON_COMPLIANCES}
    />

    <Route
      async
      component={() => import('src/pages/LawNonCompliancePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.LAW_NON_COMPLIANCE}
    />

    <Route
      async
      component={() => import('src/pages/OperatingOfficesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.OPERATING_OFFICES}
    />

    <Route
      async
      component={() => import('src/pages/OperatingOfficeVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.OPERATING_OFFICE_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/OperatingOfficePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.OPERATING_OFFICE}
    />

    <Route
      async
      component={() => import('src/pages/CompanyContactsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_CONTACTS}
    />

    <Route
      async
      component={() => import('src/pages/CompanyContactPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_CONTACT}
    />

    <Route
      async
      component={() => import('src/pages/CompanyContactVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COMPANY_CONTACT_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/StyleguidePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.STYLEGUIDE}
    />

    <Route
      async
      component={() => import('src/pages/ChecklistsComparePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.CHECKLISTS_COMPARE}
    />

    <Route
      async
      component={() => import('src/pages/ChecklistsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.CHECKLISTS}
    />

    <Route
      async
      component={() => import('src/pages/ChecklistVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.CHECKLIST_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/ChecklistPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.CHECKLIST}
    />

    <Route
      async
      component={() => import('src/pages/DatasheetsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.DATASHEETS}
    />

    <Route
      async
      component={() => import('src/pages/DatasheetVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.DATASHEET_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/DatasheetPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.DATASHEET}
    />

    <Route
      async
      component={() => import('src/pages/CustomPanelsPage/CustomPanelsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.CUSTOM_PANELS}
    />

    <Route
      async
      component={() => import('src/pages/CustomPanelPage/CustomPanelPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.CUSTOM_PANEL}
    />

    <Route
      async
      component={() => import('src/pages/CustomPanelVersionsPage/CustomPanelVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.CUSTOM_PANEL_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/ProgramCategoriesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.PROGRAM_CATEGORIES}
    />

    <Route
      async
      component={() => import('src/pages/ProgramCategoryVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.PROGRAM_CATEGORY_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/ProgramCategoryPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.PROGRAM_CATEGORY}
    />

    <Route
      async
      component={() => import('src/pages/CountryHolidaysPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COUNTRY_HOLIDAYS}
    />

    <Route
      async
      component={() => import('src/pages/CountryHolidayPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COUNTRY_HOLIDAY}
    />

    <Route
      async
      component={() => import('src/pages/CountryLanguagesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COUNTRY_LANGUAGES}
    />

    <Route
      async
      component={() => import('src/pages/CountryLanguagePage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.COUNTRY_LANGUAGE}
    />

    <Route
      async
      component={() => import('src/pages/ProductTaxonomiesPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.PRODUCT_TAXONOMIES}
    />

    <Route
      async
      component={() => import('src/pages/ProductTaxonomyVersionsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.PRODUCT_TAXONOMY_VERSIONS}
    />

    <Route
      async
      component={() => import('src/pages/ProductTaxonomyPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.PRODUCT_TAXONOMY}
    />

    <Route
      async
      component={() => import('src/pages/JobsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.JOBS}
    />

    <Route
      component={JobPage}
      exact
      layout={JobLayout}
      path={ROUTE.JOB}
    />

    <Route
      async
      component={() => import('src/pages/SurveySkinsPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SURVEY_SKINS}
    />

    <Route
      async
      component={() => import('src/pages/SurveySkinPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.SURVEY_SKIN}
    />

    <Route
      async
      component={() => import('src/pages/CreateJobPage')}
      exact
      layout={PrivateLayout}
      path={ROUTE.CREATE_JOB}
    />
    

    {/*
      * Code for investigation results for PHX-2689. To be removed after acceptance.
      */}
    <Route
      async
      component={() => import('src/pages/TestImageEditingPage')}
      exact
      layout={EmptyPrivateLayout}
      path={ROUTE.TEST_IMAGE_EDITING_PAGE}
    />

    <Route component={Error404Page} layout={PublicLayout} />
  </Switch>
);
